import { useContext } from "react";
import { NetNewContext } from "./NetNewAccount";
import { NetNewTitleMenu } from "./NetNewTitleMenu";
import { DefaultCardHeaderIcon } from "../../../assets/svg";
import { Skeleton } from "@mui/material";
import { InformationIcon } from "../../../assets/svg";
import Tooltip from '@mui/material/Tooltip';

export const NetNewHeader = () => {
  const context = useContext(NetNewContext);

  const { totalCount, generateLink, icpSelected, segmentName, tabVal, isLoading, fromDate, toDate } = context;

  return (
    <>
      <div className="net-new-header">
        <DefaultCardHeaderIcon />
        <a href={generateLink(icpSelected, segmentName, tabVal, "", "", fromDate, toDate)}>{
            isLoading ? <Skeleton variant="text" sx={{ fontSize: '1rem', width: "40px", marginTop: "-2px" }} />
            : totalCount
          } Net New Accounts
        </a>
        <div style={{ width: '32px', height: '17px', borderRadius: '4px', backgroundColor: '#00A75E', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span style={{ fontFamily: 'Inter', fontWeight: 600, fontSize: '9px', color: 'white' }}>New</span>
        </div>
        <Tooltip title="Discover new ICP-fit accounts showing engagement — via intent surges, anonymous website visits, LinkedIn interactions, and other tracked activities.">
          <div style={{ display: "flex", alignItems: "center", cursor: "pointer"}}>
            <InformationIcon />
          </div>
        </Tooltip>
        <NetNewTitleMenu />
      </div>
    </>
  );
}